// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__27-xB","footer":"ChangeClinic_footer__251Pu"};